"use client";

import Title from "@/app/components/title";
import VacanciesItem from "@/app/components/vacanties-item";
import { usePathname } from "next/navigation";

interface OurVacantiesProp {
    VacanciesTitle: string;
    vacantiesList: Array<{
        Location: string;
        metaData : {
            metaTitle: string;
            slug: string;
        }
    }>;
}

const OurVacanties: React.FC<OurVacantiesProp> = ({ VacanciesTitle, vacantiesList }) => {
    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");

    if (!vacantiesList || vacantiesList.length === 0) return null;

    return (
        <section className="mt-[136px] bg-gray-40 pt-[48px] pb-[128px] max-[767px]:mt-[50px] max-[767px]:pt-[48px] max-[576px]:mb-[64px]">
            <div className="container">
                <Title text={VacanciesTitle} position="left"/>
                <div className="flex gap-6 mt-[48px] justify-between max-[767px]:mt-[28px] max-[767px]:flex-wrap">
                    {vacantiesList.map((item: any) => {
                        const meta = item?.metaData;
                        return (
                            <div className="w-1/2 max-[767px]:w-full" key={meta?.slug}>
                            <VacanciesItem
                                title={item.title}
                                text={item?.Location || ""}
                                link={`${isEn ? "/en" : ''}/lediga-jobb/${meta?.slug}`}
                            />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default OurVacanties;
